<template>
  <div class="invoice-page">
    <div class="clear">
      <h2 class="paging-title">发票管理</h2>
    </div>
    <div class="filter-form clear">
      <div class="form-item">
        <span class="label">时间：</span>
        <div class="input-item">
          <el-date-picker
            type="date"
            size="mini"
            v-model="startTime"
            :picker-options="startOption"
            value-format="yyyy-MM-dd"
            placeholder="年-月-日"
          ></el-date-picker>
          <span class="unit">至</span>
          <el-date-picker
            type="date"
            size="mini"
            v-model="endTime"
            :picker-options="endOption"
            value-format="yyyy-MM-dd"
            placeholder="年-月-日"
          ></el-date-picker>
        </div>
      </div>
      <div class="form-item">
        <span class="label">搜索：</span>
        <div class="input-item">
          <input class="input" type="text" v-model="keyword" @keydown.enter="search" placeholder="输入工单号/订单名称" />
        </div>
      </div>
      <div class="form-item" style="margin-bottom: 20px;">
        <span class="label">平台：</span>
        <div class="input-item">
          <label class="radiobox" v-for="(item, index) in radios" :key="index">
            <input name="source2" type="radio" :value="item.value" v-model="listType" @change="search"  />
            <span class="radio-text">{{ item.label }}</span>
          </label>
        </div>
      </div>
      <div class="btn-all">
        <button class="btn-filter-bg" @click="search">查询</button>
      </div>
    </div>
    <!-- 已付工单 -->
    <div v-show="listType==0 ">
      <table class="gk-table">
        <thead>
          <tr>
            <th style="width: 200px">
              <label for="input-1">
                <input type="checkbox" name="all" class="gk-chkAll" v-model="isCheckAll" @change="pickAll(1)" />
                <span>单号</span>
              </label>
            </th>
            <th style="width: 260px">名称</th>
            <th style="width: 200px">来源</th>
            <th>完成时间</th>
            <th>金额</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in tableData" :key="index">
            <td>
              <label>
                <input type="checkbox" ref="checkItem" name="receiveAble" :value="`${item.OrderId}${item.NoteId}`" v-model="pageIds" @change="pickItem(1)" />
                <!-- <input type="checkbox" ref="checkItem" name="receiveAble" :value="item.OrderId" v-model="pageIds" @change="pickItem" /> -->
                <span>{{item.OrderNo}}</span>
              </label>
            </td>
            <td>{{item.OrderName}}</td>
            <td>{{item.OrderSourceStr}}</td>
            <td>{{item.FinishTimeStr}}</td>
            <td class="color-red">{{item.ReceivaMoney | formatPrice}}</td>
          </tr>
        </tbody>
      </table>
      <div class="all-check-box gk-table">
        <label for="input-all">
          <input type="checkbox" class="gk-chkAll" v-model="isCheckAll" @change="pickAll(1)"/>
          <!-- <input type="checkbox" class="gk-chkAll" :checked="pickedIds.length>0" /> -->
          <span>已选中<b class="gk-check-num">{{pickedIds.length}}</b>条信息</span>
        </label>
      </div>
    </div>
    <!-- 应付账款 -->
    <div v-show="listType==1">
      <table class="gk-table">
        <thead>
          <tr>
            <th style="width: 200px">
              <label for="input-1">
                <input type="checkbox" name="all" class="gk-chkAll" v-model="isCheckAll" @change="pickAll(2)" />
                <span>单号</span>
              </label>
            </th>
            <th style="width: 260px">名称</th>
            <th style="width: 200px">来源</th>
            <th>完成时间</th>
            <th>金额</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in tableData" :key="index">
            <td>
              <label>
                <input type="checkbox" ref="checkItem" name="receiveAble" :value="`${item.OrderId}${item.NoteId}`" v-model="pageIds" @change="pickItem(2)" />
                <!-- <input type="checkbox" ref="checkItem" name="receiveAble" :value="item.OrderId" v-model="pageIds" @change="pickItem" /> -->
                <span>{{item.OrderNo}}</span>
              </label>
            </td>
            <td>{{item.OrderName}}</td>
            <td>{{item.PlatFromType}}</td>
            <td>{{item.FinishTime}}</td>
            <td class="color-red">{{item.ReceivaMoney | formatPrice}}</td>
          </tr>
        </tbody>
      </table>
      <div class="all-check-box gk-table">
        <label for="input-all">
          <input type="checkbox" class="gk-chkAll" v-model="isCheckAll"  @change="pickAll(2)"/>
          <!-- <input type="checkbox" class="gk-chkAll" :checked="pickedIds.length>0"/> -->
          <span>已选中<b class="gk-check-num">{{pickedIds.length}}</b>条信息</span>
        </label>
      </div>
    </div>
    <!-- 处理中 -->
    <table class="gk-table no-gk-table" v-show="listType==2">
      <thead>
        <tr>
          <!-- <th >发票编号</th> -->
          <th>开票登记时间</th>
          <th>金额</th>
          <th>订单信息</th>
          <th>发票信息</th>
          <th >状态</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in tableData" :key="index">
          <!-- <td>{{item.InvoiceNumber}}</td> -->
          <td>{{item.InvoiceApplyDtStr}}</td>
          <td class="color-red">{{item.InvoiceMoney | formatPrice}}</td>
          <td>
            <span class="btn-text" @click="lookOrder(item)">查看详情</span>
          </td>
          <td>
            <span class="btn-text" @click="lookInvoice(item)">查看详情</span>
          </td>
          <td>{{item.InvoiceStatus}}</td>
        </tr>
      </tbody>
    </table>
    <!-- 已完成 -->
    <table class="gk-table no-gk-table"  v-show="listType==3 || listType==5">
      <thead>
        <tr>
          <th >发票编号</th>
          <th>登记时间</th>
          <th>完成时间</th>
          <th>金额</th>
          <th>订单信息</th>
          <th >发票信息</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in tableData" :key="index">
          <td>{{item.InvoiceNumber}}</td>
          <td>{{item.InvoiceApplyDtStr}}</td>
          <td>{{item.FinishTime.substr(0,10)}}</td>
          <td class="color-red">{{item.InvoiceMoney | formatPrice}}</td>
          <td>
            <span class="btn-text" @click="lookOrder(item)">查看详情</span>
          </td>
          <td>
            <span class="btn-text" @click="lookInvoice(item)">查看详情</span>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="gk-table no-gk-table"  v-show="listType==4">
      <thead>
        <tr>
          <th>登记时间</th>
          <th>完成时间</th>
          <th>金额</th>
          <th>订单信息</th>
          <!-- <th >发票信息</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in tableData" :key="index">
          <td>{{item.InvoiceApplyDtStr}}</td>
          <td>{{item.FinishTime.substr(0,10)}}</td>
          <td class="color-red">{{item.InvoiceMoney | formatPrice}}</td>
          <td>
            <span class="btn-text" @click="lookOrder(item)">查看详情</span>
          </td>
          <!-- <td>
            <span class="btn-text" @click="lookInvoice(item.OrderIds)">查看详情</span>
          </td> -->
        </tr>
      </tbody>
    </table>
    <el-pagination
      background
      layout="prev, pager, next"
      :current-page="pageIndex"
      :page-size="pageSize"
      :total="total"
      @current-change="pageChange"
    >
    </el-pagination>
    <template  v-if="listType==0 || listType==1">
      <div class="invoice-info">
        <div class="item">
          <span class="label">总开票金额：</span>
          <span class="value"><i class="unit">￥</i>{{serviceMoney |formatPrice}}</span>
        </div>
          <!-- <p class="desc">（注：服务开票金额包括6%税率，硬件开票金额包括销售税率16%）</p> -->
      </div>
      <div class="btn-group">
        <!-- <span class="btn-text" @click="isShowInfo=true">速派开票信息</span> -->
        <button class="btn-primary" @click="toApply">申请开票</button>
      </div>
    </template>
    <!-- 工单信息 -->
    <my-dialog
      :show="isShowOrderInfo"
      width="1000px"
      title="工单信息"
      @close="isShowOrderInfo=false"
      class="order-dialog"
    >
      <table class="table">
        <tr>
          <th>工单号</th>
          <th>工单名称</th>
          <th>来源</th>
          <th>发单方</th>
          <th>完成时间</th>
          <th>金额</th>
          <th>备注</th>
        </tr>
        <tr v-for="(item,index) in orderList" :key="index">
          <td>{{item.OrderNo}}</td>
          <td>{{item.OrderName}}</td>
          <td>{{item.OrderSourceStr}}</td>
          <td>{{item.SenderName}}</td>
          <td>{{item.FinishDtStr}}</td>
          <td>{{item.Amount | formatPrice}}</td>
          <td>{{item.Remark}}</td>
        </tr>
      </table>
    </my-dialog>
    <!-- 申请开票 -->
    <my-dialog
      :show="isShowApply"
      width="600px"
      title="申请开票"
      @close="isShowApply=false"
      class="invoice-dialog"
    >
      <el-form ref="form" :model="form" label-width="130px" size="medium">
        <el-form-item label="发票类型：">
          <el-radio-group v-model="form.IsVatInvoice">
            <el-radio name="invoiceType" :label="true">增值税专用发票</el-radio>
            <el-radio name="invoiceType" :label="false">增值税普通发票</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发票抬头：">
          <el-input  v-model="form.InvoiceTitle" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别码：">
          <el-input  v-model="form.TaxNo" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="注册地址：">
          <el-input  v-model="form.CompanyAddress" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="注册电话号码：">
          <el-input  v-model="form.CompanyPhone" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="开户银行：">
          <el-input  v-model="form.UserAccountOrgName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="银行账号：">
          <el-input  v-model="form.UserAccountNo" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="开票内容：">
          <el-radio-group v-model="form.InvoiceContent">
            <el-radio name="content" label="技术服务费">技术服务费</el-radio>
            <el-radio name="content" label="技术咨询费">技术咨询费</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开票金额：">
          <div class="value price">{{form.Money | formatPrice}}</div>
        </el-form-item>
        <el-form-item label="开票税点：">
          <div class="value">{{form.TaxPoint*100}}%</div>
        </el-form-item>
        <el-form-item label="发票备注：">
          <el-input  v-model="form.InvoiceRemarks" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="发票邮箱地址：">
          <el-input  v-model="form.InvoiceMailAddress" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="收件人：">
          <el-input  v-model="form.Consignee" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="收件人电话：">
          <el-input  v-model="form.ConsigneePhone" placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <button class="btn-primary" @click="confirmApply">确认</button>
    </my-dialog>
    <!-- 发票信息 -->
    <my-dialog
      :show="isShowInfo"
      width="600px"
      title="发票详情"
      @close="isShowInfo=false"
      class="invoice-dialog"
    >
      <el-form ref="info" :model="info" label-width="130px" size="medium">
        <el-form-item label="申请开票时间：">
          <!-- <div class="value">{{info.CreateTime?info.CreateTime.substr(0,10):''}}</div> -->
          <div class="value">{{info.ApplyTimeStr || '--'}}</div>
        </el-form-item>
        <el-form-item label="发票类型：">
          <div class="value">{{info.IsVatInvoice?'增值税专用发票':'增值税普通发票'}}</div>
        </el-form-item>
        <el-form-item label="发票抬头：">
          <div class="value">{{info.InvoiceTitle || '--'}}</div>
        </el-form-item>
        <el-form-item label="纳税人识别码：">
          <div class="value">{{info.TaxNo || '--'}}</div>
        </el-form-item>
        <el-form-item label="注册地址：">
          <div class="value">{{info.CompanyAddress || '--'}}</div>
        </el-form-item>
        <el-form-item label="注册电话号码：">
          <div class="value">{{info.CompanyPhone || '--'}}</div>
        </el-form-item>
        <el-form-item label="开户银行：">
          <div class="value">{{info.UserAccountOrgName || '--'}}</div>
        </el-form-item>
        <el-form-item label="银行账号：">
          <div class="value">{{info.UserAccountNo || '--'}}</div>
        </el-form-item>
        <el-form-item label="开票内容：">
          <div class="value">{{info.InvoiceContent || '--'}}</div>
        </el-form-item>
        <el-form-item label="开票金额：">
          <div class="value price">{{info.InvoiceMoney | formatPrice}}</div>
        </el-form-item>
        <el-form-item label="开票税点：">
          <div class="value">{{info.TaxPoint*100}}%</div>
        </el-form-item>
        <el-form-item label="发票备注：">
          <div class="value">{{info.InvoiceRemarks || '--'}}</div>
        </el-form-item>
        <el-form-item label="发票邮箱地址：">
          <div class="value">{{info.InvoiceMailAddress || '--'}}</div>
        </el-form-item>
        <el-form-item label="收件人：">
          <div class="value">{{info.Consignee || '--'}}</div>
        </el-form-item>
        <el-form-item label="收件人电话：">
          <div class="value">{{info.ConsigneePhone || '--'}}</div>
        </el-form-item>
        <el-form-item label="发票编码：">
          <div class="value">{{info.InvoiceNumber || '--'}}</div>
        </el-form-item>
      </el-form>
      <button class="btn-primary" @click="isShowInfo=false">关闭</button>
    </my-dialog>
  </div>
</template>
<script>
import Dialog from "@/components/gkDialog.vue";
import {
  InvoiceableOrderView,
  InvoicehistoryByPC,
  GetOrdersByInvoice,
  GetListPayable,
  SenderConfirmInvoiceView,
  SenderConfirmInvoiceCommit,
  PayableSenderConfirmInvoiceCommit,
  InvoiceDetail,
  ApplyInvoice,
  GetInvoice,
  GetOrderListByInvoiceId,
} from "@/scripts/api.js";
import { mapState } from "vuex";
export default {
  components: {
    "my-dialog": Dialog,
  },
  data() {
    return {
      radios: [
        {
          label: "已付订单/工单",
          value: 0,
        },
        {
          label: "应付账款",
          value: 1,
        },
        {
          label: "发票处理中",
          value: 2,
        },
        {
          label: "发票待付款",
          value: 7,
        },
        {
          label: "发票已完成",
          value: 3,
        },
        {
          label: "发票已拒绝",
          value: 4,
        },
      ],
      listType: 0,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      startTime:'',
      endTime:'',
      keyword:'',
      tableData: [],
      loading: false,
      isShowApply:false,//申请开票弹框
      isShowInfo:false,
      pageIds:[],//当页选中数组
      pickedIds:[],//跨页选中数组

      confirmIds: [], //提交数据


      pickedNodeIds:[],//跨页选中的项目节点数组
      serviceMoney:0,
      isCheckAll:false,
      isShowOrderInfo:false,
      orderList:[],
      form:{
        IsVatInvoice:true,
        InvoiceTitle :'',
        TaxNo :'',
        CompanyAddress:'',
        CompanyPhone :'',
        UserAccountOrgName :'',
        UserAccountNo :'',
        InvoiceContent:'',
        InvoiceMailAddress :'',
        Consignee :'',
        ConsigneePhone :'',
        Money :'',
        TaxPoint  :'',
        InvoiceRemarks :'',
      },
      info:{},
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
    startOption(){
      //开始时间不可选择的日期
      let obj={disabledDate:null};
      let that=this;
      if(that.endTime){
        obj={
          disabledDate(time) {
            return time.getTime() > new Date(that.endTime).getTime();
          }
        }
      }else{
        obj={
          disabledDate(time) {
            return time.getTime() >  Date.now();
          }
        }
      }
      return obj;
    },
    endOption(){
      //结束时间不可选择的日期
      let obj={disabledDate:null};
      let that=this;
      if(that.startTime){
        obj={
          disabledDate(time) {
            return time.getTime() < new Date(that.startTime).getTime()-8*60*60*1000 || time.getTime() >  Date.now();
          }
        }
      }else{
        obj={
          disabledDate(time) {
            return time.getTime() >  Date.now();
          }
        }
      }
      return obj;
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    search(){
      this.pageNum=1;
      this.pageIds=[];//当页选中数组
      this.pickedIds=[];//跨页选中数组
      this.confirmIds = [];
      this.pickedNodeIds=[];
      this.serviceMoney=0;
      this.isCheckAll=false;
      this.loading=false;
      if(this.listType==0){
        this.loadData();
      }else if(this.listType==1){
        this.loadPayAble();
      }else{
        this.loadHistory();
      }
    },
    //全选
    pickAll(is){
      let arr=[];
      for (let i = 0; i < this.tableData.length; i++) {
        if(this.isCheckAll){
          //全选当前页id
          arr.push(`${this.tableData[i].OrderId}${this.tableData[i].NoteId}`);
          // arr.push(this.tableData[i].OrderId);
        }else{
          arr=[];
        }
      }
      this.pageIds=arr;
      this.pickItem(is);
    },
    //逐一选择
    pickItem(is){
      for (let i = 0; i < this.tableData.length; i++) {
        let orderNoteId = `${this.tableData[i].OrderId}${this.tableData[i].NoteId}`
        // if(this.pageIds.indexOf(this.tableData[i].OrderId)!==-1 && this.pickedIds.indexOf(this.tableData[i].OrderId)==-1){
        if(this.pageIds.indexOf(orderNoteId)!==-1 && this.pickedIds.indexOf(orderNoteId)==-1){
          //如果选中数组里含有当前表的某个id，且 跨页选中数组里没有该id，则加入跨页数组中 ————选中操作
          this.pickedIds.push(`${this.tableData[i].OrderId}${this.tableData[i].NoteId}`);
          this.confirmIds.push(this.tableData[i].OrderId)
          // this.pickedIds.push(this.tableData[i].OrderId);
          this.pickedNodeIds.push(this.tableData[i].NoteId);
          if(is == 1) {
            this.serviceMoney=this.serviceMoney+this.tableData[i].ServiceMoney;
          }else {
            this.serviceMoney=this.serviceMoney+this.tableData[i].ReceivaMoney;
          }
          
        }
        // if(this.pageIds.indexOf(this.tableData[i].OrderId)==-1 && this.pickedIds.indexOf(this.tableData[i].OrderId)!==-1){
        if(this.pageIds.indexOf(orderNoteId)==-1 && this.pickedIds.indexOf(orderNoteId)!==-1){
          //如果选中数组里不含当前表的某个id，且 跨页选中数组里含有该id，则加入跨页数组中————取消操作
          this.pickedIds.splice(this.pickedIds.indexOf(`${this.tableData[i].OrderId}${this.tableData[i].NoteId}`),1);
          this.confirmIds.splice(this.confirmIds.indexOf(this.tableData[i].OrderId),1)
          // this.pickedIds.splice(this.pickedIds.indexOf(this.tableData[i].OrderId),1);
          this.pickedNodeIds.splice(this.pickedNodeIds.indexOf(this.tableData[i].NoteId),1);
          if(is == 1) {
            this.serviceMoney=this.serviceMoney-this.tableData[i].ServiceMoney;
          }else {
            this.serviceMoney=this.serviceMoney-this.tableData[i].ReceivaMoney;
          }
        }
      }
    },
    //已付工单
    loadData() {
      if (this.loading) return;
      this.loading = true;
      let params = {
        KeyWord:this.keyword,
        StartDate:this.startTime + ' 00:00:01',
        EndDate:this.endTime + ' 23:59:59',
        PageNo: this.pageNum,
        PageSize: this.pageSize,
        UserCode: this.userInfo.UserCode,
        IsReceiver:false,
      };
      if(!this.startTime) {
        params.StartDate = ''
      }
      if(!this.endTime) {
        params.EndDate = ''
      }
      InvoiceableOrderView(params).then((r) => {
        this.loading = false;
        if (r.Result == 1) {
          this.tableData = r.Data.Lines || [];
          this.total = r.Data.TotalAmount;
          //获取本页已选择数据
          this.pageIds=[];//清空本页选中项目
          this.isCheckAll=false;
          for (let i = 0; i < this.tableData.length; i++) {
            // if(this.pickedIds.indexOf(this.tableData[i].OrderId)!=-1){
            //   this.pageIds.push(this.tableData[i].OrderId);
            // }
            if(this.pickedIds.indexOf(`${this.tableData[i].OrderId}${this.tableData[i].NoteId}`)!=-1){
              this.pageIds.push(`${this.tableData[i].OrderId}${this.tableData[i].NoteId}`);
            }
          }
          //如果本页已选数等于pageSize，表示本页已全选
          if(this.pageIds.length==this.pageSize){
            this.isCheckAll=true;
          }
        }else{
          this.$toast(r.Message);
        }
      });
    },
    //应付账款
    loadPayAble() {
      if (this.loading) return;
      this.loading = true;
      let params = {
        KeyWord:this.keyword,
        IsReceiver:true,
        StartDate:this.startTime + ' 00:00:01',
        EndDate:this.endTime + ' 23:59:59',
        PageNo: this.pageNum,
        PageSize: this.pageSize,
        UserCode: this.userInfo.UserCode,
      };
      if(!this.startTime) {
        params.StartDate = ''
      }
      if(!this.endTime) {
        params.EndDate = ''
      }
      GetListPayable(params).then((r) => {
        this.loading = false;
        if (r.Result == 1) {
          this.tableData = r.Data.Lines || [];
          this.total = r.Data.TotalSize;
          //获取本页已选择数据
          this.pageIds=[];//清空本页选中项目
          this.isCheckAll=false;
          for (let i = 0; i < this.tableData.length; i++) {
            // if(this.pickedIds.indexOf(this.tableData[i].OrderId)!=-1){
            //   this.pageIds.push(this.tableData[i].OrderId);
            // }
            if(this.pickedIds.indexOf(`${this.tableData[i].OrderId}${this.tableData[i].NoteId}`)!=-1){
              this.pageIds.push(`${this.tableData[i].OrderId}${this.tableData[i].NoteId}`);
            }
          }
          //如果本页已选数等于pageSize，表示本页已全选
          if(this.pageIds.length==this.pageSize){
            this.isCheckAll=true;
          }
        }else{
          this.$toast(r.Message);
        }
      });
    },
    //获取处理中和已完成发票
    loadHistory(){
      if (this.loading) return;
      this.loading = true;
      let params = {
        Keyword:this.keyword,
        StartDate:this.startTime + ' 00:00:01',
        EndDate:this.endTime + ' 23:59:59',
        IsReceiver:false,
        InvoiceStatuses:this.listType==2?'0,1,2,5':this.listType,
        PageNo: this.pageNum,
        PageSize: this.pageSize,
        UserCode: this.userInfo.UserCode,
      };
      if(!this.startTime) {
        params.StartDate = ''
      }
      if(!this.endTime) {
        params.EndDate = ''
      }
      InvoicehistoryByPC(params).then((r) => {
        this.loading = false;
        if (r.Result == 1) {
          this.tableData = r.Data.Lines || [];
          this.total = r.Data.TotalAmount;
        }else{
          this.$toast(r.Message);
        }
      });
    },
    //分页跳转
    pageChange(data) {
      this.pageNum = data;
      if(this.listType==0){
        this.loadData();
      }else if(this.listType==1){
        this.loadPayAble();
      }else{
        this.loadHistory();
      }
    },
    //去开票信息页
    toApply(){
      // if(this.pickedIds.length==0){
      //   this.$toast('请选择至少一条');
      //   return;
      // }
      if(this.confirmIds.length==0){
        this.$toast('请选择至少一条');
        return;
      }
      let ids=this.confirmIds.join(',');
      // let ids=this.pickedIds.join(',');
      let nodes=this.pickedNodeIds.join(',');
      this.$refs.form.resetFields();
      if(this.listType==0){
        SenderConfirmInvoiceView({
          UserCode:this.userInfo.UserCode,
          OrderIds:ids,
          NoteIds:nodes
        }).then(r=>{
          if(r.Result==1){
            let data=r.Data;
            for (let k in this.form) {
              if(Object.hasOwnProperty.call(this.form,k)){
                this.form[k]=data[k];
              }
            }
            this.form.Money=data.InvoiceMoney;
            this.isShowApply=true;
          }else{
            this.$toast(r.Message);
          }
        })
      }else{
        ApplyInvoice({
          UserCode:this.userInfo.UserCode,
          OrderIds:ids,
          IsReceiver:true,
          NoteIds:nodes,
        }).then(r=>{
          if(r.Result==1){
            let data=r.Data;
            for (let k in this.form) {
              if(Object.hasOwnProperty.call(this.form,k)){
                this.form[k]=data[k];
              }
            }
            this.form.Money=data.InvoiceMoney;
            this.isShowApply=true;
          }else{
            this.$toast(r.Message);
          }
        })
      }
    },
    //提交开票申请
    confirmApply(){
      let ids=this.confirmIds.join(',');
      // let ids=this.pickedIds.join(',');
      let nodes=this.pickedNodeIds.join(',');
      if(this.listType==0){
        SenderConfirmInvoiceCommit({
          ...this.form,
          UserCode:this.userInfo.UserCode,
          OrderIds:ids,
          NoteIds:nodes,
          InvoiceTitleType:this.userInfo.LoginAccountType==1?2:1,
        }).then(r=>{
          if(r.Result==1){
            this.$toast('申请成功！');
            this.isShowApply=false;
            this.search();
          }else{
            this.$toast(r.Message);
          }
        })
      }else{
        PayableSenderConfirmInvoiceCommit({
          ...this.form,
          UserCode:this.userInfo.UserCode,
          OrderIds:ids,
          NoteIds:nodes,
          InvoiceTitleType:this.userInfo.LoginAccountType==1?2:1,
        }).then(r=>{
          if(r.Result==1){
            this.$toast('申请成功！');
            this.isShowApply=false;
            this.search();
          }else{
            this.$toast(r.Message);
          }
        })
      }
      
    },
    //查看工单
    lookOrder(item){
      if(!item.IsLimitPayment){
        GetOrdersByInvoice({
          UserCode: this.userInfo.UserCode,
          InvoiceId:item.InvoiceId,
        }).then(r=>{
          if(r.Result==1){
            this.orderList = r.Data.Lines || [];
            this.isShowOrderInfo=true;
          }else{
            this.$toast(r.Message);
          }
        })
      }else{
        GetOrderListByInvoiceId({
          UserCode: this.userInfo.UserCode,
          InvoiceId:item.InvoiceId,
        }).then(r=>{
          if(r.Result==1){
            this.orderList = r.Data || [];
            this.isShowOrderInfo=true;
          }else{
            this.$toast(r.Message);
          }
        })
      }
    },
    //查看发票
    lookInvoice(item){
      this.info={};
      if(!item.IsLimitPayment){
        InvoiceDetail({
          UserCode:this.userInfo.UserCode,
          InvoiceId:item.InvoiceId,
          IsReceiver:false,
        }).then(r=>{
          if(r.Result==1){
            this.info=r.Data.Invoice;
            this.isShowInfo=true;
          }else{
            this.$toast(r.Message);
          }
        })
      }else{
        GetInvoice({
          UserCode:this.userInfo.UserCode,
          Id:item.InvoiceId,
          IsReceiver:false,
        }).then(r=>{
          if(r.Result==1){
            this.info=r.Data;
            this.isShowInfo=true;
          }else{
            this.$toast(r.Message);
          }
        })
      }
    },
  },
};
</script>
<style lang="scss">
.invoice-page {
  .filter-form {
    background-color: #f8f8f8;
    padding: 25px 20px 0px;
    overflow: hidden;
    position: relative;
    padding-right: 90px;
    margin-top: 20px;
    .form-item {
      margin-bottom: 16px;
      float: left;
      overflow: hidden;
      margin-right: 30px;
    }
    .btn-group {
      float: right;
    }
    .label {
      float: left;
      font-size: 14px;
      color: #666;
      line-height: 30px;
    }
    .el-input{
      width: 160px;
    }
    .input-item {
      float: left;
      min-width: 160px;
    }
    .input {
      width: 160px;
      border: 1px solid #e5e5e5;
      background-color: #fff;
      padding: 4px 10px;
      font-size: 14px;
      color: #333;
      line-height: 20px;
      height: 30px;
    }
    .unit{
      font-size: 14px;
      color: #666;
      line-height: 30px;
      padding-left: 5px;
      padding-right: 5px;
    }
    .radiobox {
      display: inline-block;
      margin-right: 20px;
      position: relative;
      margin-top: 3px;
      cursor: pointer;
      input {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        font-size: 100px;
      }
      .radio-text {
        display: inline-block;
        padding: 0 16px;
        font-size: 14px;
        color: #666;
        border-radius: 2px;
        height: 24px;
        line-height: 24px;
      }
      input:checked + .radio-text {
        background-color: #f75959;
        color: #fff;
      }
    }
    .btn-all {
      position: absolute;
      right: 20px;
      top: 25px;
      font-size: 14px;
      .btn-filter-bg {
        height: 30px;
        width: 60px;
        background-color: #f75959;
        color: #fff;
        cursor: pointer;
      }
      .btn-filter-no-bg {
        color: #f75959;
        margin-left: 4px;
        background: none;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .gk-table {
    width: 100%;
    table-layout: fixed;
    margin-top: 20px;
    th {
      padding: 12px 20px;
      border-bottom: 1px solid #f75959;
      color: #999;
      font-size: 14px;
      line-height: 24px;
      text-align: left;
    }
    // th:first-child {
    //     padding-left: 20px;
    // }
    th:last-child,
    td:last-child {
      text-align: right;
    }
    // td:last-child {
    //     color: #f75959;
    //     font-weight: 600;
    // }
    .color-red {
      color: #f75959;
      font-weight: 600;
    }
    tr {
      border-bottom: 1px solid #e2e2e2;
      td {
        padding: 12px 20px;
        height: 99px;
        font-size: 14px;
        color: #999;
      }
    }
    input[type="checkbox"] {
      display: inline-block;
      -webkit-appearance: none;
      background: #fff url(../../assets/checkbox_icon.png);
      height: 14px;
      vertical-align: middle;
      width: 14px;
      background-size: cover;
      cursor: pointer;
      margin-right: 4px;
      margin-top: -2px;
    }
    input[type="checkbox"]:checked {
      background-position: -16px 0;
    }
    .btn-text{
      cursor: pointer;
      &:hover{
        color: #f75959;
      }
    }
  }
  .el-pagination {
    text-align: right;
    margin-top: 30px;
  }
  .no-gk-table {
    th:last-child,
    td:last-child {
      text-align: left;
    }
    td:last-child {
      color: #999;
      font-weight: normal;
    }
  }
  .invoice-info {
    background: #f9f9f9;
    padding: 25px 22px;
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: right;
    .item{
      font-size: 14px;
      line-height: 24px;
      text-align: right;
      margin-bottom: 10px;
    }
    .label{
      display: inline-block;
      color: #666;
    }
    .value{
      display: inline-block;
      min-width: 60px;
      color: #f75959;
    }
    .unit{
      font-size: 12px;
    }
    .desc{
      font-size: 12px;
      color: #999;
      line-height: 20px;
      margin-top: 6px;
      margin-bottom: 0;
    }
  }
  .all-check-box {
    margin-left: 20px;
    span {
      font-size: 14px;
      color: #999;
      display: inline-block;
      vertical-align: middle;
      padding-left: 6px;
      line-height: 22px;
    }
  }
  .btn-group {
    text-align: right;
    margin-bottom: 80px;
    .btn-text{
      display: inline-block;
      color: #666;
      font-size: 14px;
      line-height: 30px;
      margin-right: 10px;
      cursor: pointer;
      &:hover{
        color: #f75959;
      }
    }
    .btn-primary {
      width: 100px;
      line-height: 30px;
      border: none;
      line-height: 30px;
      text-align: center;
      display: inline-block;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .invoice-dialog{
    .dialog-body{
      padding-top: 10px;
      padding-bottom: 20px;
      height: 80vh;
      overflow-y: auto;
    }
    .el-form-item{
      overflow: hidden;
      line-height: 24px;
      margin-bottom: 14px;
      .el-form-item__label{
        font-size: 16px;
        color: #333;
        font-weight: bold;
      }
      .value{
        font-size: 14px;
        color: #333;
      }
    }
    .btn-primary{
      display: block;
      width: 100px;
      height: 30px;
      margin: 0 auto;
      cursor: pointer;
    }
  }
  
  .table {
    width: 100%;
      // border: 1px solid #e5e5e5;
    th {
      padding: 12px 20px;
      border: 1px solid #e5e5e5;
      color: #333;
      font-size: 14px;
      line-height: 24px;
      font-weight: bold;
    }
    td {
      padding: 12px 20px;
      line-height: 24px;
      font-size: 14px;
      color: #666;
      border: 1px solid #e5e5e5;
    }
  }
}
</style>
